<template>
  <div class="level" style="width: 100%;">
    <div class="jiangli_top">
      <icon name="arrow-left" @click="$router.go(-1)" />
      <p>{{ detail.title || "视频会议" }}</p>
    </div>
    <div class="level_con" v-if="detail">
      <div style="display: flex; align-items: center; flex-flow: column;">
        <h1
          style="font-size: 0.36rem;margin-bottom:10px;text-align:center;width: 100%;"
        >
          {{ detail.title }}
        </h1>
      </div>
      <img v-if="detail.image" :src="detail.image" class="detailImage" />
      <div v-if="detail.content" v-html="detail.content" class="content"></div>
      <div v-if="detail.link" class="meeting-link-box">
        <p class="meeting-tip">长按复制会议链接</p>
        <p class="meeting-link" @click="copyLink">{{ detail.link }}</p>
      </div>
    </div>
    <div style="height: 50px;"></div>
  </div>
</template>

<script>
import request from "@utils/request";
import { goodsImage, rewriteHtmlAssets } from "@utils/goodsImage";
import Icon from "vant/lib/icon";
import "vant/lib/icon/style";

export default {
  name: "VideoMeetingDetail",
  components: { Icon },
  data() {
    return {
      detail: null
    };
  },
  created() {
    this.loadDetail();
  },
  methods: {
    copyLink() {
      const text = this.detail && this.detail.link;
      if (!text) return;
      const el = document.createElement("textarea");
      el.value = text;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      el.select();
      el.setSelectionRange(0, el.value.length);
      document.execCommand("copy");
      el.remove();
      this.$toast.success("已复制会议链接");
    },
    loadDetail() {
      const id = this.$route.query.id;
      if (!id) {
        this.$router.back();
        return;
      }
      request
        .get("/api/v1/video/detail", { id }, { login: false })
        .then(res => {
          const payload = res && res.data ? res.data : res;
          const data = (payload && payload.data) || null;
          if (data) {
            data.image = goodsImage(data.image);
            data.content = rewriteHtmlAssets(data.content);
            document.title = data.title || "视频会议";
          }
          this.detail = data;
        })
        .catch(() => {
          this.detail = null;
        });
    }
  }
};
</script>

<style scoped>
.jiangli_top {
  width: 100%;
  height: 50px;
  background-color: #ff1900;
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
}
.jiangli_top i {
  position: absolute;
  top: 13px;
  left: 16px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  font-size: 24px;
  color: #fff;
}
.jiangli_top p {
  margin: 0;
  line-height: 50px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  padding: 0 40px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.level_con {
  width: 100%;
  overflow-x: hidden;
  margin-top: 50px;
  padding: 15px;
  background: #fff;
}
.detailImage {
  max-width: 100%;
  border-radius: 5px;
  display: inline-block;
  height: auto;
  margin-bottom: 10px;
}
.content >>> img {
  max-width: 100% !important;
  display: inline-block !important;
  height: auto !important;
}
.meeting-link-box {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #f2f2f2;
}
.meeting-tip {
  margin: 0 0 8px;
  color: #333;
  font-size: 14px;
}
.meeting-link {
  margin: 0;
  color: #333;
  font-size: 14px;
  line-height: 1.7;
  word-break: break-all;
  user-select: all;
  -webkit-user-select: all;
}
</style>
